<template>
  <div class="content_main">
    <p class="content_normal">We act as Solicitors to CASHIGO INTERNATIONAL LIMITED, who will shall
      hereafter refer to as Our Client and on whose instruction we now write.</p>
    <br />
    <p class="content_normal">Therefore, this letter requires you to pay and return it to the mail
      or company immediately.</p>
    <br />
    <p class="content_normal">Regards. Therefore, this letter requires you to pay and return it to
      the mail or company immediately.</p>
    <br />
    <p class="content_normal">Note: If you fail to pay, we will use all available methods to seek
      justice, which will obviously make you pay more.</p>
    <br />
    <p class="content_normal">While waiting for your prompt reply, please make sure that we can best
      you.</p>
    <br />
    <p class="content_normal">Regards.</p>
  </div>
</template>

<script>
export default {
  name: 'M2',
};
</script>


<style lang="stylus" scoped>
px = (1 / 24.75vw);
.content {
  padding: 25 *px 16 *px;
  .content_main{
    line-height: 20px;
    text-indent: 16px;
    margin-top: 16px;
  }
  .content_normal {
    text-align: left;
    text-indent: 16px;
  }
}
</style>
